interface EmptyStateProps {
  title: string;
  body?: string;
}

export default function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="card flex flex-col items-center justify-center p-8 text-center">
      <div
        aria-hidden="true"
        className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400"
      >
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          <path d="M12 8v4l2.5 2.5" />
        </svg>
      </div>
      <p className="text-base font-medium">{title}</p>
      {body && <p className="mt-1 max-w-sm text-sm text-zinc-500">{body}</p>}
    </div>
  );
}
